import { useQuery } from '@tanstack/react-query';

import { checkDiscountCode } from 'api/jalapeno';

export const QUERY_KEY = 'check-discount-code';

const fetchDiscountCode = async (customerID, discountCode) => {
    const response = await checkDiscountCode(customerID, discountCode);

    return { ...response.data };
};

const useCheckDiscountCodeQuery = ({ customerID, discountCode, extendedQueryKeys = [], queryProps }) => {
    const query = useQuery({
        queryKey: [QUERY_KEY, ...extendedQueryKeys],
        queryFn: () => fetchDiscountCode(customerID, discountCode),
        enabled: !!discountCode,
        ...queryProps,
    });

    return query;
};

export default useCheckDiscountCodeQuery;
